import { escapeForCSV } from '../../../core/utils/download.js';
import { CategoricalBarChartData } from '../types/categorical-bar-chart.js';

export function formatCSV(categories: CategoricalBarChartData[]) {
  const isSingleDimension = typeof categories[0].value === 'number';
  let csv = '';
  let columns = ['category', 'value'];
  if (!isSingleDimension) {
    columns = ['category', 'key', 'value'];
  }

  for (const category of categories) {
    if (isSingleDimension) {
      const sanitizedCategory = escapeForCSV(category.category);
      csv += `${sanitizedCategory},${category.value},\n`;
    } else {
      for (const [dimensionName, dimensionValue] of Object.entries(
        category.value,
      )) {
        const sanitizedCategory = escapeForCSV(category.category);
        const sanitizedName = escapeForCSV(dimensionName);
        csv += `${sanitizedCategory},${sanitizedName},${dimensionValue},\n`;
      }
    }
  }

  csv = `${columns.join(',')}\n${csv}`;

  return csv;
}
